module.exports = __webpack_public_path__ + "static/media/salad1.cc270c95.png";